<ion-content class="ion-no-padding">
  <form class="lead-form model-container" [formGroup]="campaignForm" *ngIf="campaignForm">
    <ion-header class="model-header ion-no-border ion-padding-horizontal sticky-top bg-white">
      <ion-toolbar class="header-first-toolbar">
        <ion-title class="text-start ion-no-padding title-blue">Create New Campaign</ion-title>
        <ion-buttons slot="end" class="ion-no-margin">
          <ion-button (click)="closeModal()" class="unfilled-gray-btn">
            <ion-icon name="close-outline"></ion-icon>
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>

    <div class="model-content campign-main-container">

      <div class="campign-form-container">
        <ion-title class="dark-title-sm ion-padding-horizontal py-1 bg-light-gray">Campaign Details</ion-title>
        <div class="ion-padding-horizontal">
          <div class="row">
            <div class="col-12">
              <div class="input-container">
                <label for="" class="label">Campaign Name*</label>
                <div [ngClass]="{ 'invalid-input': campaignForm.get('name')?.invalid && campaignForm.get('name')?.touched }">
                  <input type="text" placeholder="Enter your campaign name" class="input" formControlName="name">
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="input-container">
                <label for="" class="label">Select Message Template*</label>
                <div [ngClass]="{ 'invalid-input': campaignForm.get('templateId')?.invalid && campaignForm.get('templateId')?.touched }">
                  <select name="" id="" class="input" formControlName="templateId">
                    <option value="" hidden>Select a Template</option>
                    <ng-container *ngFor="let item of templates">
                      <option *ngIf="item.templateId" [value]="item.templateId">{{item.name}}</option>
                    </ng-container>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Schedule -->
        <ion-title class="dark-title-sm ion-padding-horizontal py-1 bg-light-gray mt-2">Schedule</ion-title>
        <div class="ion-padding-horizontal">
          <div class="row pt-2">
            <div class="col-4">
              <div class="input-container">
                <div class="d-flex align-items-center">
                  <input type="radio" name="scheduleType" id="scheduleNow" value="scheduleNow" formControlName="schedule">
                  <label for="scheduleNow" class="label">Send Now</label>
                </div>
              </div>
            </div>
            <div class="col-4">
              <div class="input-container">
                <div class="d-flex align-items-center">
                  <input type="radio" name="scheduleType" id="scheduleLater" value="scheduleLater" formControlName="schedule">
                  <label for="scheduleLater" class="label">Schedule Later</label>
                </div>
              </div>
            </div>
          </div>
          <div class="row" *ngIf="campaignForm.get('schedule')?.value === 'scheduleLater'">
            <div class="col-4">
              <div class="input-container">
                <label for="" class="label">Select Date*</label>
                <div [ngClass]="{ 'invalid-input': campaignForm.get('scheduleDate')?.invalid && campaignForm.get('scheduleDate')?.touched }">
                  <app-date-picker formControlName="scheduleDate" [minDate]="today"></app-date-picker>
                </div>
              </div>
            </div>
            <div class="col-4">
              <div class="input-container">
                <label for="" class="label">Select Time*</label>
                <div [ngClass]="{ 'invalid-input': campaignForm.get('scheduleTime')?.invalid && campaignForm.get('scheduleTime')?.touched }">
                  <app-time-picker formControlName="scheduleTime"></app-time-picker>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Contacts -->
        <ion-title class="dark-title-sm ion-padding-horizontal py-1 bg-light-gray mt-2">Select Contacts</ion-title>
        <div class="input-container ion-padding-horizontal pt-1 mb-0" *ngIf="campaignForm.get('selectedContacts')?.invalid && campaignForm.get('selectedContacts')?.touched ">
          <p class="warning-message mb-0">Select at least 1 contact</p>
        </div>
        <div class="ion-padding-horizontal py-2">
          <app-contacts-selection formControlName="selectedContacts"></app-contacts-selection>
        </div>
      </div>
      <div class="campaign-preview-container">
        <ion-title class="dark-title-sm ion-padding-horizontal py-1 bg-light-gray">Preview</ion-title>
      </div>
    </div>


    <!-- Save button -->
    <div class="model-footer ion-padding-horizontal bg-light-gray justify-content-center">
      <ion-button class="unfilled-blue-btn" type="submit">Reset</ion-button>
      <ion-button class="filled-blue-btn" type="submit">Save & Draft</ion-button>
      <ion-button class="filled-blue-btn" type="submit" (click)="onSubmit()">Submit</ion-button>
    </div>

  </form>
</ion-content>